<template>
  <div class="question-item" :class="{'hide-add-button': props.hideNewButton}">
<!--    <div class="requirement-drag">-->
<!--      <i class="pi pi-ellipsis-v"></i>-->
<!--      <i class="pi pi-ellipsis-v"></i>-->
<!--    </div>-->

    <div class='question'>
      <div class='p-button-outlined question-title-button justify-end custom-button' @click='showTooltipMenu'>
        <i class='pi pi-ellipsis-h'></i>
      </div>

      <TieredMenu ref='tooltipMenu' :model='tooltipMenuItems' :popup='true' />
      <FormField title='Question:' placeholder='Enter what Creator question...' class='p-fluid' iconRight='pi pi-pencil'
                 v-model='question.question' :maxLength='500' />
    </div>

  </div>
</template>

<script setup>
import FormField from '../../FormField';
import {ref} from "vue";
import {useVModel} from "@vueuse/core";

const emit = defineEmits(['add', 'delete']);
const props = defineProps({
  question: {type: Object, required: true},
  index: {type: Number, required: true},
  hideNewButton: {type: Boolean}
});

const question = useVModel(props, 'question', emit, {deep: true});

const tooltipMenu = ref();
const tooltipMenuItems = [
  {
    label: 'Delete',
    icon: 'pi pi-fw pi-trash',
    command: () => emit('delete', props.index)
  }
];

const showTooltipMenu = (event) => tooltipMenu.value.toggle(event)
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/theme_variables";

.question-item {
  position: relative;
  margin-left: toRem(-24);
  padding-left: toRem(24);

  .question-drag {
    opacity: 0;
    visibility: hidden;
  }

  &:hover {
    .question-drag {
      opacity: 1;
      visibility: visible;
    }
  }
}

.question {
  position: relative;
  padding: toRem(16);
  background: $gray;
  border-radius: 12px;
}

.question-drag {
  position: absolute;
  top: toRem(14);
  left: 0;
  cursor: pointer;
  overflow: hidden;
  width: 20px;
  color: $textThirdColor;
  transition: opacity 0.3s, visibility 0.3s;
  display: flex;

  .pi {
    width: 6px;

    &:first-child {
      margin-left: -6.5px;
    }
  }
}

.question-title {
  display: flex;
  margin-bottom: toRem(12);
  font-size: 18px;
  font-weight: bold;
  align-items: center;

  ::v-deep(.p-button.question-title-button) {
    padding: toRem(5);
    width: 20px;
    height: 20px;
    margin-left: toRem(8);

    .pi {
      font-size: 9px !important;
    }
  }

}

.duration-list {
  display: flex;
  justify-content: space-between;
  margin-top: toRem(2);
}

.duration {
  flex: 1;
  padding: toRem(8) 0;
  background: $bgBlocks;
  border-radius: $borderRadius;
  text-align: center;
  cursor: pointer;
  border: 1px solid transparent;
  font-weight: 500;
  font-size: 1rem;

  & + & {
    margin-left: toRem(8);
  }

  &.selected {
    border-color: #0F8BFD;
    color: $primaryColor;
  }
}

::v-deep(.p-inputtext) {
  padding-top: toRem(10);
  padding-left: toRem(8);
  padding-bottom: toRem(10);
  background: $bgBlocks;
  font-size: toRem(14);
}

div.custom-button {
  color: #676b89 !important;
  border: none !important;
  float: right !important;
}
</style>
